import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c66b297c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "cases-container"
}
const _hoisted_2 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  href: "/responses"
}
const _hoisted_5 = {
  key: 2,
  id: "cases-container",
  "aria-label": "Case management"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "case-status__status" }
const _hoisted_8 = { class: "case-status__count" }

import { faBallotCheck } from 'fontawesome/pro-regular-svg-icons'
import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import { TimeOptionLabel } from '@/utils/time'
import { Cases } from '@/entities/frontlineManagerDash'
import Skeleton from 'primevue/skeleton'

interface Props {
    cases: Cases | undefined
    loading: boolean
    timeFilter: TimeOptionLabel
    responseCount: number
    detractorCount: number
    isMobile: boolean
    showError?: boolean
    onReloadClick?: Function
    onViewCasesClick: Function
}

const caseManagementZendeskUrl =
    'https://asknicely.zendesk.com/hc/en-us/articles/4401970053652-Keep-Track-Of-Your-Responses-With-Case-Management'

export default /*#__PURE__*/_defineComponent({
  __name: 'Cases',
  props: {
    cases: {},
    loading: { type: Boolean },
    timeFilter: {},
    responseCount: {},
    detractorCount: {},
    isMobile: { type: Boolean },
    showError: { type: Boolean },
    onReloadClick: { type: Function },
    onViewCasesClick: { type: Function }
  },
  setup(__props: any) {

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DashboardCard, {
    title: "Cases",
    icon: _unref(faBallotCheck),
    "response-count": _ctx.responseCount,
    "action-label": "View cases",
    "on-action-click": _ctx.onViewCasesClick,
    "aria-busy": _ctx.loading,
    "show-error": _ctx.showError,
    "on-reload-click": _ctx.onReloadClick
  }, {
    content: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (skeleton) => {
              return _createElementVNode("div", {
                key: skeleton,
                class: "case-status case-status--loading"
              }, [
                _createElementVNode("div", null, [
                  _createVNode(_unref(Skeleton), {
                    width: "100px",
                    "data-testid": "loading"
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_unref(Skeleton), {
                    width: "50px",
                    "data-testid": "loading"
                  })
                ])
              ])
            }), 64))
          ]))
        : (!_ctx.cases || _ctx.cases.all <= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                (_ctx.detractorCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "You have " + _toDisplayString(_ctx.detractorCount) + " detractor responses in the last " + _toDisplayString(_ctx.timeFilter.label) + ".", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" Open your first "),
                (_ctx.isMobile)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 1,
                      to: "/myfeedback"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("case")
                      ], undefined, true),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("a", _hoisted_4, "case")),
                _createTextVNode(" to start tracking responses. ")
              ]),
              _createElementVNode("a", {
                href: caseManagementZendeskUrl,
                target: "_blank",
                class: "find-out-link"
              }, " Find out how Cases improve your organization's customer experience. ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (count, status) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: status,
                  class: _normalizeClass(['case-status', `case-status--${status}`]),
                  "aria-label": `${status}: ${count} cases`
                }, [
                  _createElementVNode("dt", _hoisted_7, _toDisplayString(status), 1),
                  _createElementVNode("dd", _hoisted_8, _toDisplayString(count), 1)
                ], 10, _hoisted_6))
              }), 128))
            ]))
    ]),
    _: 1
  }, 8, ["icon", "response-count", "on-action-click", "aria-busy", "show-error", "on-reload-click"]))
}
}

})